import { formatDate } from '@/helpers/format-date';
import { TableSecondaryCell } from '@/ui/table/infinite-table/table-cells';
import { styled } from 'goober';

export const ProjectLastModifiedCell = ({
  lastEditedDate,
}: {
  lastEditedDate: string | null;
}) => {
  if (!lastEditedDate) {
    return null;
  }
  return (
    <TableSecondaryCell>
      {lastEditedDate ? <Text>{formatDate(lastEditedDate)}</Text> : null}
    </TableSecondaryCell>
  );
};

const Text = styled('p')`
  ${({ theme }) => theme.typography.globalSearch.suggestionsTable.smallText};
`;
